import { gql } from '@grandvisionhq/graphql';
import { appointmentFragment } from '../../../fragments/appointment.js';

const CANCEL_APPOINTMENT_BY_ID = gql`
  mutation CancelAppointmentById($id: ID!, $cancellationReason: String) {
    cancelAppointment(id: $id, cancellationReason: $cancellationReason) {
      ...AppointmentFragment
    }
  }
  ${appointmentFragment}
`;

export { CANCEL_APPOINTMENT_BY_ID };
//# sourceMappingURL=cancel-appointment-by-id.js.map
